<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <!-- 版本信息区域 -->
          <div class="version-info">
            <span class="version-label">当前版本：</span>
            <Tag color="primary" size="large">{{ versionInfo.version || '暂无版本' }}</Tag>
            <span v-if="versionInfo.created_at" class="version-date">
              发布时间：{{ versionInfo.created_at }}
            </span>
            <Button type="success" icon="ios-cloud-upload" style="margin-left: 20px;" @click="showPublishModal">
              发布新版本
            </Button>
          </div>
          <Divider />

          <!-- 搜索区域 -->
          <div class="search-con search-con-top">
            <Input
              class="search-input"
              v-model="searchVal"
              style="padding:5px; width: 300px;"
              placeholder="输入行业代码或名称搜索"
              @on-enter="handleSearch"
              clearable
            />
            <Button type="primary" icon="ios-search" @click="handleSearch" class="search-btn">搜索</Button>
            <Button type="primary" icon="ios-add" @click="showAddModal(null)" class="search-btn">新增行业分类</Button>
          </div>

          <Spin size="large" fix v-if="spinShow"></Spin>

          <!-- 树形表格 -->
          <Table
            ref="industryTable"
            :columns="columns"
            :data="tableData"
            :loading="loading"
            :load-data="handleLoadData"
            row-key="id"
            border
            size="small"
            :indent-size="20"
          >
          </Table>
        </Card>
      </i-col>
    </Row>

    <!-- 新增/编辑模态框 -->
    <Modal
      v-model="formModal.visible"
      :title="formModal.title"
      :loading="formModal.loading"
      :footer-hide="true"
      :mask-closable="false"
      width="500"
    >
      <Form ref="industryForm" :model="formData" :rules="formRules" :label-width="100">
        <FormItem label="行业代码" prop="code">
          <Input v-model="formData.code" placeholder="请输入行业代码，如 A、B06、C131" :disabled="formModal.isEdit" />
        </FormItem>
        <FormItem label="行业名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入行业名称" />
        </FormItem>
        <FormItem label="父级分类" prop="parent_code">
          <div v-if="formData.parent_code">
            <Tag color="primary">{{ formData.parent_code }} - {{ formData.parent_name }}</Tag>
          </div>
          <span v-else style="color: #808695;">无（一级分类）</span>
        </FormItem>
        <FormItem label="排序" prop="sort_order">
          <InputNumber v-model="formData.sort_order" :min="0" :max="9999" style="width: 100%;" />
        </FormItem>
        <FormItem label="状态" prop="status">
          <i-switch v-model="formData.status" :true-value="1" :false-value="0">
            <span slot="open">启用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit">提交</Button>
          <Button @click="handleReset" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 设置产业类型模态框 -->
    <Modal
      v-model="industryTypeModal.visible"
      title="设置产业归类"
      :loading="industryTypeModal.loading"
      @on-ok="handleSetIndustryType"
    >
      <Form :label-width="100">
        <FormItem label="行业分类">
          <span>{{ industryTypeModal.currentItem.code }} - {{ industryTypeModal.currentItem.name }}</span>
        </FormItem>
        <FormItem label="产业类型">
          <Select v-model="industryTypeModal.selectedType" placeholder="请选择产业类型" clearable>
            <Option :value="1">第一产业</Option>
            <Option :value="2">第二产业</Option>
            <Option :value="3">第三产业</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

    <!-- 发布新版本模态框 -->
    <Modal
      v-model="publishModal.visible"
      title="发布新版本"
      :loading="publishModal.loading"
      @on-ok="handlePublishVersion"
    >
      <Form ref="publishForm" :model="publishModal" :rules="publishRules" :label-width="100">
        <FormItem label="更新说明" prop="updateNote">
          <Input
            v-model="publishModal.updateNote"
            type="textarea"
            :rows="4"
            placeholder="请输入本次更新说明"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import {
  getIndustryList,
  loadIndustryChildren,
  createIndustry,
  updateIndustry,
  deleteIndustry,
  setIndustryType,
  publishVersion,
  getCurrentVersion
} from '@/api/industry/industry.js'

export default {
  name: 'IndustryManage',
  data () {
    return {
      spinShow: false,
      loading: false,
      searchVal: '',
      tableData: [],
      allData: [], // 保存所有数据用于构建父级选项

      // 版本信息
      versionInfo: {
        version: '',
        update_note: '',
        created_at: ''
      },

      // 表单模态框
      formModal: {
        visible: false,
        title: '新增行业分类',
        loading: false,
        isEdit: false
      },

      // 表单数据
      formData: {
        id: null,
        code: '',
        name: '',
        parent_code: null,
        parent_name: '',
        level: 1,
        sort_order: 0,
        status: 1
      },

      // 表单验证规则
      formRules: {
        code: [
          { required: true, message: '行业代码不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '行业名称不能为空', trigger: 'blur' }
        ]
      },

      // 产业类型模态框
      industryTypeModal: {
        visible: false,
        loading: false,
        currentItem: {},
        selectedType: null
      },

      // 发布版本模态框
      publishModal: {
        visible: false,
        loading: false,
        updateNote: ''
      },

      // 发布表单验证
      publishRules: {
        updateNote: [
          { required: true, message: '更新说明不能为空', trigger: 'blur' }
        ]
      },

      // 产业类型映射
      industryTypeMap: {
        1: { text: '第一产业', color: 'success' },
        2: { text: '第二产业', color: 'primary' },
        3: { text: '第三产业', color: 'warning' }
      },

      // 表格列配置
      columns: [
        {
          title: '行业代码',
          key: 'code',
          width: 150,
          tree: true
        },
        {
          title: '行业名称',
          key: 'name',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '层级',
          key: 'level',
          width: 80,
          align: 'center',
          render: (h, params) => {
            const levelMap = {
              1: { text: '一级', color: 'error' },
              2: { text: '二级', color: 'warning' },
              3: { text: '三级', color: 'default' }
            }
            const level = levelMap[params.row.level] || { text: '-', color: 'default' }
            return h('Tag', { props: { color: level.color } }, level.text)
          }
        },
        {
          title: '产业归类',
          key: 'industry_type',
          width: 140,
          align: 'center',
          render: (h, params) => {
            // 只有一级分类显示产业归类
            if (params.row.level !== 1) {
              return h('span', '-')
            }
            const type = this.industryTypeMap[params.row.industry_type]
            if (type) {
              return h('div', [
                h('Tag', { props: { color: type.color } }, type.text),
                h('Button', {
                  props: { type: 'text', size: 'small' },
                  style: { marginLeft: '5px' },
                  on: { click: () => this.showIndustryTypeModal(params.row) }
                }, '修改')
              ])
            }
            return h('Button', {
              props: { type: 'dashed', size: 'small' },
              on: { click: () => this.showIndustryTypeModal(params.row) }
            }, '设置')
          }
        },
        {
          title: '排序',
          key: 'sort_order',
          width: 80,
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.status === 1 ? 'success' : 'default'
              }
            }, params.row.status === 1 ? '启用' : '禁用')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showEditModal(params.row) }
              }, '编辑')
            ]

            // 只有一级和二级分类可以添加子分类
            if (params.row.level < 3) {
              buttons.push(
                h('Button', {
                  props: { type: 'success', size: 'small' },
                  style: { marginRight: '5px' },
                  on: { click: () => this.showAddModal(params.row) }
                }, '添加子类')
              )
            }

            // buttons.push(
            //   h('Button', {
            //     props: { type: 'error', size: 'small' },
            //     on: { click: () => this.handleDelete(params.row) }
            //   }, '删除')
            // )

            return h('div', buttons)
          }
        }
      ]
    }
  },

  computed: {
    // 保留空的 computed，后续可添加其他计算属性
  },

  methods: {
    // 扁平化树形数据
    flattenData (data, result) {
      if (!Array.isArray(data)) return
      data.forEach(item => {
        result.push({
          id: item.id,
          code: item.code,
          name: item.name,
          level: item.level
        })
        if (item.children && item.children.length > 0) {
          this.flattenData(item.children, result)
        }
      })
    },

    // 获取行业分类列表（初始只加载一级分类）
    async getList () {
      this.loading = true
      try {
        const params = {}
        if (this.searchVal) {
          params.keyword = this.searchVal
        }
        const res = await getIndustryList(params)
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data
          if (Array.isArray(data)) {
            this.allData = data
            // 搜索时需要构建树形结构，非搜索时后端已返回带children标记的数据
            this.tableData = this.searchVal ? this.buildTreeData(data) : data
          } else {
            this.allData = []
            this.tableData = []
          }
        } else {
          this.$Message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$Message.error('获取数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    // 懒加载子节点
    handleLoadData (item, callback) {
      loadIndustryChildren(item.code).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          const children = res.data.data || []
          callback(children)
        } else {
          this.$Message.error(res.data.message || '加载子分类失败')
          callback([])
        }
      }).catch(error => {
        this.$Message.error('加载子分类失败: ' + error.message)
        callback([])
      })
    },

    // 构建树形数据
    buildTreeData (data) {
      if (!data || data.length === 0) return []

      // 如果后端已经返回树形结构，直接使用
      if (data[0] && data[0].children !== undefined) {
        return data
      }

      // 否则自己构建树形结构
      const map = {}
      const result = []

      // 首先创建所有节点的映射
      data.forEach(item => {
        map[item.code] = { ...item, children: [] }
      })

      // 构建树形结构
      data.forEach(item => {
        const node = map[item.code]
        if (item.parent_code && map[item.parent_code]) {
          map[item.parent_code].children.push(node)
        } else if (!item.parent_code) {
          result.push(node)
        }
      })

      // 对每一层进行排序
      const sortChildren = (nodes) => {
        nodes.sort((a, b) => a.sort_order - b.sort_order)
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            sortChildren(node.children)
          }
        })
      }
      sortChildren(result)

      return result
    },

    // 获取当前版本信息
    async getVersion () {
      try {
        const res = await getCurrentVersion()
        if (res.data.code === 200 || res.data.code === 0) {
          this.versionInfo = res.data.data || {}
        }
      } catch (error) {
        console.error('获取版本信息失败:', error)
      }
    },

    // 搜索
    handleSearch () {
      this.getList()
    },

    // 显示新增模态框
    showAddModal (parentRow) {
      this.formModal.visible = true
      this.formModal.title = parentRow ? `添加子分类 - ${parentRow.name}` : '新增行业分类'
      this.formModal.isEdit = false
      this.formData = {
        id: null,
        code: '',
        name: '',
        parent_code: parentRow ? parentRow.code : null,
        parent_name: parentRow ? parentRow.name : '',
        level: parentRow ? parentRow.level + 1 : 1,
        sort_order: 0,
        status: 1
      }
    },

    // 显示编辑模态框
    showEditModal (row) {
      this.formModal.visible = true
      this.formModal.title = '编辑行业分类'
      this.formModal.isEdit = true
      this.formData = {
        id: row.id,
        code: row.code,
        name: row.name,
        parent_code: row.parent_code,
        parent_name: row.parent_name || '',
        level: row.level,
        sort_order: row.sort_order,
        status: row.status
      }
    },

    // 提交表单
    handleSubmit () {
      this.$refs.industryForm.validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请检查表单填写')
          return
        }

        this.formModal.loading = true
        try {
          const submitData = {
            code: this.formData.code,
            name: this.formData.name,
            parent_code: this.formData.parent_code,
            level: this.formData.level,
            sort_order: this.formData.sort_order,
            status: this.formData.status
          }

          let res
          if (this.formModal.isEdit) {
            res = await updateIndustry(this.formData.id, submitData)
          } else {
            res = await createIndustry(submitData)
          }

          if (res.data.code === 200 || res.data.code === 0) {
            this.$Message.success(this.formModal.isEdit ? '修改成功' : '添加成功')
            this.formModal.visible = false
            this.getList()
          } else {
            this.$Message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$Message.error('操作失败: ' + error.message)
        } finally {
          this.formModal.loading = false
        }
      })
    },

    // 重置表单
    handleReset () {
      this.$refs.industryForm.resetFields()
    },

    // 删除
    handleDelete (row) {
      const hasChildren = row.children && row.children.length > 0
      const confirmMsg = hasChildren
        ? `确定要删除 "${row.name}" 及其所有子分类吗？此操作不可恢复！`
        : `确定要删除 "${row.name}" 吗？`

      this.$Modal.confirm({
        title: '确认删除',
        content: confirmMsg,
        onOk: async () => {
          try {
            const res = await deleteIndustry(row.id)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getList()
            } else {
              this.$Message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败: ' + error.message)
          }
        }
      })
    },

    // 显示产业类型设置模态框
    showIndustryTypeModal (row) {
      this.industryTypeModal.visible = true
      this.industryTypeModal.currentItem = row
      this.industryTypeModal.selectedType = row.industry_type || null
    },

    // 设置产业类型
    async handleSetIndustryType () {
      if (this.industryTypeModal.selectedType === null) {
        this.$Message.warning('请选择产业类型')
        return
      }

      this.industryTypeModal.loading = true
      try {
        const res = await setIndustryType(
          this.industryTypeModal.currentItem.id,
          this.industryTypeModal.selectedType
        )
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('设置成功')
          this.industryTypeModal.visible = false
          this.getList()
        } else {
          this.$Message.error(res.data.message || '设置失败')
        }
      } catch (error) {
        this.$Message.error('设置失败: ' + error.message)
      } finally {
        this.industryTypeModal.loading = false
      }
    },

    // 显示发布版本模态框
    showPublishModal () {
      this.publishModal.visible = true
      this.publishModal.updateNote = ''
    },

    // 发布新版本
    async handlePublishVersion () {
      if (!this.publishModal.updateNote.trim()) {
        this.$Message.warning('请输入更新说明')
        return
      }

      this.publishModal.loading = true
      try {
        const res = await publishVersion({
          update_note: this.publishModal.updateNote
        })
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('发布成功')
          this.publishModal.visible = false
          this.getVersion()
        } else {
          this.$Message.error(res.data.message || '发布失败')
        }
      } catch (error) {
        this.$Message.error('发布失败: ' + error.message)
      } finally {
        this.publishModal.loading = false
      }
    }
  },

  mounted () {
    this.getList()
    this.getVersion()
  }
}
</script>

<style lang="less" scoped>
.version-info {
  display: flex;
  align-items: center;
  padding: 10px 0;

  .version-label {
    font-weight: bold;
    margin-right: 10px;
  }

  .version-date {
    margin-left: 20px;
    color: #808695;
    font-size: 13px;
  }
}

.search-con {
  padding: 10px 0;

  .search-input {
    display: inline-block;
    margin-right: 10px;
  }

  .search-btn {
    margin-left: 5px;
  }
}

/deep/ .ivu-table-cell-tree {
  .ivu-table-cell-tree-level {
    width: 16px;
  }
}
</style>
